import {
  type CaseStatus,
  type PricingType,
  type VisitOccurrenceStatus,
  type VisitStatus,
  type VisitType,
} from "./types";

export const VisitTypes: Record<VisitType, VisitType> = {
  ADMISSION: "ADMISSION",
  ADMISSION_AND_FIRST_VISIT: "ADMISSION_AND_FIRST_VISIT",
  DISCHARGE: "DISCHARGE",
  EVALUATION: "EVALUATION",
  NURSING_EVAL: "NURSING_EVAL",
  RECERTIFICATION: "RECERTIFICATION",
  REGULAR: "REGULAR",
  RESUMPTION_OF_CARE: "RESUMPTION_OF_CARE",
  SUPERVISORY: "SUPERVISORY",
};

export const VisitPricingTypes: Record<PricingType, PricingType> = {
  PER_HOUR: "PER_HOUR",
  PER_VISIT: "PER_VISIT",
};

export const VisitStatuses: Record<VisitStatus, VisitStatus> = {
  LOGGED: "LOGGED",
  CANCELED: "CANCELED",
  PENDING: "PENDING",
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  CONFIRMED: "CONFIRMED",
  FILLED: "FILLED",
};

export const CaseStatuses: Record<CaseStatus, CaseStatus> = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
};

export const readableVisitTypeMapping: Record<VisitType, string> = {
  REGULAR: "Regular visit",
  ADMISSION: "Admission",
  ADMISSION_AND_FIRST_VISIT: "Admission and first visit",
  EVALUATION: "Evaluation",
  DISCHARGE: "Discharge",
  SUPERVISORY: "Supervisory",
  RESUMPTION_OF_CARE: "Resumption of care",
  RECERTIFICATION: "Recertification",
  NURSING_EVAL: "Nursing evaluation",
};

export const shortenedDaysOfWeekMapping: Record<string, string> = {
  Sunday: "Su",
  Monday: "M",
  Tuesday: "Tu",
  Wednesday: "W",
  Thursday: "Th",
  Friday: "F",
  Saturday: "Sa",
};

export const caseHistoryStatusLabels: Record<CaseStatus, string> = {
  OPEN: "Active",
  CLOSED: "Closed",
};

export const VisitOccurrenceStatuses: Record<VisitOccurrenceStatus, VisitOccurrenceStatus> = {
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  REJECTED: "REJECTED",
};

export const BAA_SIGNATURE_NAME = "business-associate-agreement";
